import { render, staticRenderFns } from "./toggle-button.vue?vue&type=template&id=74ca4752&scoped=true"
import script from "./toggle-button.vue?vue&type=script&lang=js"
export * from "./toggle-button.vue?vue&type=script&lang=js"
import style0 from "./toggle-button.vue?vue&type=style&index=0&id=74ca4752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ca4752",
  null
  
)

export default component.exports